import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

export default () => {
  const { commit } = useStore()
  const route = useRoute()

  function createDiscussion (parsedData) {
    if (route.name === 'Discussions') {
      const bookIds = route.query.spaces.split(',').map(i => parseInt(i))

      if (bookIds.includes(parseInt(parsedData.payload.bookId))) {
        commit('addDiscussion', parsedData.payload.value)
      }
    }
  }

  function updateDiscussion (parsedData) {
    commit('updateDiscussion', parsedData.payload.value)
  }

  function deleteDiscussion (parsedData) {
    commit('deleteDiscussion', parsedData.payload.value.id)
  }

  function addMessage (parsedData) {
    const discussionId = route.params.discussionId

    if (parseInt(discussionId) === parsedData.payload.message.discussionId) {
      commit('setDiscussionMessage', parsedData.payload.message)
    }

    commit('updateDiscussionMessagesCount', {
      ...parsedData.payload.message,
      state: 'add'
    })
  }

  function updateMessage (parsedData) {
    commit('updateDiscussionMessage', parsedData.payload.value)
  }

  function deleteMessage (parsedData) {
    commit('deleteDiscussionMessage', parsedData.payload.value.id)
    commit('updateDiscussionMessagesCount', {
      ...parsedData.payload.value,
      state: 'delete'
    })
  }

  function toggleReaction (parsedData) {
    commit('toggleReaction', {
      messageId: parsedData.payload.value.messageId,
      reactionId: parsedData.payload.value.reactionId,
      discussionId: parsedData.payload.value.discussionId,
      userId: parsedData.payload.value.userId,
      user: parsedData.payload.value.user,
      isSelected: parsedData.payload.value.method !== 'add'
    })
  }

  function resolveDiscussion (parsedData) {
    commit('resolve', {
      messageId: parsedData.payload.value.messageId,
      resolvedAt: parsedData.payload.value.resolvedAt,
      discussionId: parsedData.payload.value.discussionId
    })
  }

  return {
    createDiscussion,
    updateDiscussion,
    deleteDiscussion,
    resolveDiscussion,
    addMessage,
    updateMessage,
    deleteMessage,
    toggleReaction
  }
}
